import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { useSearchContext } from '@lumahealthhq/ui-components/ContainerTable/contexts/SearchContext';
import { IconActivityOutlined, IconFilterOutlined, IconSearchOff, Stack, Typography } from '@lumahealthhq/ui-core';
import { getState } from './utils';
import useIntlEmptyContentMessages from './utils/hooks/useIntlEmptyContentMessages';

/**
 * @ignore - internal component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const sizeIcon = {
  width: '40px',
  height: '40px'
};
const icon = {
  emptyState: /*#__PURE__*/_jsx(IconActivityOutlined, {
    sx: ({
      palette
    }) => _extends({
      color: palette.grey[600]
    }, sizeIcon)
  }),
  searchState: /*#__PURE__*/_jsx(IconSearchOff, {
    sx: ({
      palette
    }) => _extends({
      color: palette.grey[600]
    }, sizeIcon)
  }),
  filterState: /*#__PURE__*/_jsx(IconFilterOutlined, {
    sx: ({
      palette
    }) => _extends({
      color: palette.grey[600]
    }, sizeIcon)
  })
};
export default function TableEmptyContent({
  isFiltered
}) {
  const {
    searchValue
  } = useSearchContext();
  const messages = useIntlEmptyContentMessages(searchValue);
  const state = getState(isFiltered, searchValue);
  return /*#__PURE__*/_jsxs(Stack, {
    gap: 1,
    alignItems: "center",
    children: [icon[state], /*#__PURE__*/_jsxs(Stack, {
      gap: 0.5,
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        color: "text.primary",
        children: messages[state].title
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "body1",
        color: "text.primary",
        children: messages[state].subtitle
      })]
    })]
  });
}